import "./resetPassword.scss";
import loginlogo from "../../assets/images/login-logo.svg";
import loginimage from "../../assets/images/login-image.jpg";
import passwordResetModalImage from "../../assets/images/pass-reset-succes-image.svg";
import Form from "react-bootstrap/Form";
import { Button, Modal, Image, Container, Row, Col, FormText } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import useAuth from "../../Hooks/useAuth";
import Loading from "../../components/LoadingPage/Loading";
import { splitPasswordPolicyError } from "../../utils/commonUtils";
import ReCAPTCHA from "react-google-recaptcha";
import { useAppSelector } from "../../redux/hooks";
import { selectConfigData } from "../../redux/config/configSlice";

const ResetPassword = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showVerifyPassword, setShowVerifyPassword] = useState(false);
  const [passChangeErr, setPassChangeErr] = useState<string>('');
  const [isVerified, setIsVerified] = useState(true);
  const location = useLocation();
  const {
    verifyResetPassApi,
    verifyResetPassLoading,
    resetPasswordApi,
    resetPasswordLoading,
    verifyCaptchaApi,
  } = useAuth();
  const configData = useAppSelector(selectConfigData);
  const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  // Create a URLSearchParams object to parse the query parameters
  const queryParams = new URLSearchParams(location.search);

  // Extract parameters
  const clientId = queryParams.get("clientId") ?? "";
  const userEmailId = queryParams.get("userEmailId") ?? "";
  const uniqueKey = queryParams.get("uniqueKey") ?? "";

    const payload = {
      uniqueId: uniqueKey,
      userEmailId: userEmailId,
      clientId: clientId,
    };

  useEffect(() => {
    verifyResetPassApi(payload)
      .then()
      .catch((errpr) => {
        setIsVerified(false);
      });
  }, []);

  const { handleChange, handleBlur, values, handleSubmit, touched, errors, setFieldValue } = useFormik({
    initialValues: {
      password: "",
      userEmailId: userEmailId ?? "",
      clientId: clientId ?? "",
      confirmPassword: "",
      uniqueId: uniqueKey ?? "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        // .min(8, "Password must be at least 8 characters long")
        // .matches(/[0-9]/, "Password must contain at least one number")
        // .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
        // .matches(/[a-z]/, "Password must contain at least one lowercase letter")
        // .matches(
        //   /[\W_]/,
        //   "Password must contain at least one special character",
        // )
        .required("Password is Required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password")], "Passwords must match")
        .required("Confirm Password is Required"),
    }),

    onSubmit: async (values: any) => {
      if (!captchaToken) {
        return;
      }
      try {
        await verifyCaptchaApi(captchaToken);
        const res = await resetPasswordApi(values);
        if (!res?.result && res?.errorDetails) {
          setPassChangeErr(res.errorDetails);
          return;
        }
        setPassChangeErr('');
        handleShow();
      } catch (error) {
        console.error("Failed to reset the password:", error);
      } finally {
        recaptchaRef.current?.reset();
        setCaptchaToken(null);
      }
    },
  });
  return (
    <div className="reset-password-wrapper">
      {verifyResetPassLoading || resetPasswordLoading ? <Loading /> : null}
      <Container fluid>
        <Row style={{ minHeight: "100vh" }}>
          <Col xs={12} md={6}>
            {isVerified ? (
              <div className="login-form-wrapper">
                <figure>
                  <img src={loginlogo} alt="logo" />
                </figure>
                <div className="login-title-wrapper">
                  <h4>Reset your Password</h4>
                  <p>Enter a new password to reset your current password</p>
                </div>
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-4 password-field-box">
                    <Form.Label>New Password</Form.Label>
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter New Password"
                      id="password"
                      name="password"
                      onChange={(e) =>
                        handleChange("password")(e.target.value ?? "")
                      }
                      value={values.password}
                      isInvalid={touched.password && !!errors.password}
                      onBlur={(e) => {
                        handleBlur(e);
                        setFieldValue("password", e.target.value.trim());
                      }}
                    />
                    {touched.password && errors.password ? (
                      <Form.Control.Feedback type="invalid">
                        {errors.password as string}
                      </Form.Control.Feedback>
                    ) : null}

                    {showPassword ? (
                      <i
                        className="bi bi-eye-fill"
                        onClick={() => {
                          setShowPassword(!showPassword);
                        }}
                      />
                    ) : (
                      <i
                        className="bi bi-eye-slash-fill"
                        onClick={() => {
                          setShowPassword(!showPassword);
                        }}
                      />
                    )}
                  </Form.Group>
                  <Form.Group className="mb-4 password-field-box">
                    <Form.Label>Confirm Your Password</Form.Label>
                    <Form.Control
                      type={showVerifyPassword ? "text" : "password"}
                      placeholder="Confirm Your Password"
                      id="confirmPassword"
                      name="confirmPassword"
                      onChange={(e) =>
                        handleChange("confirmPassword")(e.target.value ?? "")
                      }
                      value={values.confirmPassword}
                      isInvalid={
                        touched.confirmPassword && !!errors.confirmPassword
                      }
                      onBlur={(e) => {
                        handleBlur(e);
                        setFieldValue("confirmPassword", e.target.value.trim());
                      }}
                    />
                    {touched.confirmPassword && errors.confirmPassword ? (
                      <Form.Control.Feedback type="invalid">
                        {errors.confirmPassword as string}
                      </Form.Control.Feedback>
                    ) : null}

                    {showVerifyPassword ? (
                      <i
                        className="bi bi-eye-fill"
                        onClick={() => {
                          setShowVerifyPassword(!showVerifyPassword);
                        }}
                      />
                    ) : (
                      <i
                        className="bi bi-eye-slash-fill"
                        onClick={() => {
                          setShowVerifyPassword(!showVerifyPassword);
                        }}
                      />
                    )}
                  </Form.Group>
                  {passChangeErr && (
                    <Form.Group className="d-flex flex-column mb-4">
                      {splitPasswordPolicyError(passChangeErr)?.map((item, index) => (
                        <FormText key={item + index} className="text-danger">{item}</FormText>
                      ))}
                    </Form.Group>
                  )}
                  {configData?.recaptchaSiteKey && (
                    <Form.Group className="mb-4">
                      <ReCAPTCHA
                        ref={recaptchaRef}
                        sitekey={configData.recaptchaSiteKey}
                        onChange={(token) => setCaptchaToken(token)}
                        onExpired={() => setCaptchaToken(null)}
                        onErrored={() => setCaptchaToken(null)}
                      />
                    </Form.Group>
                  )}
                  <Form.Group className="d-grid">
                    <Button type="submit" variant="primary" disabled={!captchaToken}>
                      Change Password
                    </Button>
                  </Form.Group>
                </Form>
                <div className="login-bottom-wrapper">
                  <Link to="/login">
                    <i className="bi bi-arrow-left"></i> Return to the
                    Sign in Screen
                  </Link>
                </div>
              </div>
            ) : (
              <div className="display-center">
                <h4>link expired</h4>
              </div>
            )}
          </Col>

          <Col
            style={{
              backgroundImage: `url(${loginimage})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center center",
              backgroundSize: "cover",
            }}
            item
            xs={12}
            md={6}
          >
            <div className="login-image-wrapper">
              <h4>Company</h4>
              <h1>Overview</h1>
              <p>
                TriNet Medical provides Healthcare IT solutions with
                quantifiable results in the areas of Data Management services,
                Technology Services and Barcode Integration with EMR.
              </p>
              <p>
                We deliver highly valuable and innovative solutions that bridge
                our client's execution gaps through a clear understanding of
                their business needs and a culture of shared commitments.
              </p>
              <div className="url-link-box">
                <Link
                  className="text-primary-700"
                  to="https://www.trinetmedical.com/"
                  target="_blank"
                >
                  www.trinetmedical.com
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <Modal id="password-link-success-modal" show={show} onHide={handleClose}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Image src={passwordResetModalImage} alt="img" />
          <h5>Password Reset</h5>
          <p>
            Your Password has been successfully reset, <br />
            Click below to continue your access.
          </p>
          <Button
            type="button"
            variant="primary"
            onClick={() => navigate("/login")}
          >
            Continue
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ResetPassword;
